












import Vue, { PropType } from 'vue';
import SearchCard, { CardInfo } from '@/components/SearchCard/SearchCard.vue';
import { City } from '@/store/modules/location/state';

export default Vue.extend({
  components: {
    SearchCard,
  },
  props: {
    cities: {
      type: Array as PropType<City[]>,
      required: true,
    },
    selectedCity: {
      type: String,
      default: '',
    },
  },
  computed: {
    items(): CardInfo[] {
      const items: CardInfo[] = this.cities.map(({ city, state }, index) => ({
        key: index,
        content: { title: `${city}, ${state}`, icon: 'location' },
      }));

      return items;
    },
    selected(): number {
      return this.cities.findIndex(({ city, state }) => `${city}, ${state}` === this.selectedCity);
    },
  },
  methods: {
    // resolve pelo índice do card, não pelo título renderizado. `City` não tem id no
    // store, então o índice é a chave estável aqui — o problema nunca foi o `key: index`,
    // foi procurar a cidade comparando a string `"Cidade, UF"`: qualquer drift de copy
    // ou espaçamento vindo da API devolvia `undefined` e o dispatch ia com city vazia.
    selectedHandler(selectedCard: CardInfo) {
      const selected = this.cities[selectedCard.key];

      if (!selected) return;

      setTimeout(() => {
        this.$emit('selected', selected);
      }, 300);
    },
  },
});
